import {list} from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";

export const SELECTED_PODEPISUJICI_TO_FILTER = "selectedPodepisujiciToFilter";
export const SELECTED_ROLE_TO_FILTER = "selectedRoleToFilter";
export const PODEPISUJICI_LIST = "podepisujiciList";

const getPodepisujiciByIds = (ids) => {
    return QSignAdminApi.findSignerByIds(ids);
};

const getAllPodepisujiciIds = (parent, filter) => {
    return QSignAdminApi.findSignerIds(filter);
};

export function fetchIfNeeded(forceFetch) {
    return (dispatch) => {
        dispatch(
            list.InfiniteListActions.fetchIfNeeded(PODEPISUJICI_LIST, null, getAllPodepisujiciIds, getPodepisujiciByIds, forceFetch)
        );
    };
}

export function loadMore() {
    return (dispatch, getState) => {
        dispatch(list.InfiniteListActions.loadMore(PODEPISUJICI_LIST, getPodepisujiciByIds));
    };
}

export function invalidate() {
    return (dispatch) => {
        dispatch(list.InfiniteListActions.invalidate(PODEPISUJICI_LIST));
    };
}

export function setFilter(fulltext, role) {
    return (dispatch, getState) => {
            dispatch(filterPodepisujici(PODEPISUJICI_LIST, {fulltext: fulltext, role: role}))
    }
}

export function filterPodepisujici(area, filter) {
    return list.InfiniteListActions.filter(area, filter);
}
